$(document).ready(function () {
  console.log("wf-countdown.js loaded");
  function updateCountdown($element) {
    // Extract the date from the data attribute and parse it into a valid date format
    var targetDateString = $element.data("date");

    // Use Date.UTC to construct the target date in UTC
    var targetDate = new Date(
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(new Date(targetDateString))
    );

    // Get the current date adjusted to the America/New_York time zone using Intl.DateTimeFormat
    var currentDate = new Date(
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(new Date())
    );

    var timeRemaining = targetDate.getTime() - currentDate.getTime();

    if (timeRemaining > 0) {
      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      $element.find(".days").text(days);
      $element.find(".hours").text(hours);
      $element.find(".minutes").text(minutes);
      $element.find(".seconds").text(seconds);
    }
  }

  $(".countdown").each(function () {
    var $this = $(this);
    updateCountdown($this);
    setInterval(function () {
      updateCountdown($this);
    }, 1000);
  });
});
